(() => {
  if (window.featherCartCheckoutBarLoaded) return;
  window.featherCartCheckoutBarLoaded = true;

  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 699px)');
  let cleanup = () => {};

  function initialise() {
    cleanup();
    const bar = document.querySelector('.cart-checkout-action');
    if (!bar) return;
    const controller = new AbortController();
    const options = { signal: controller.signal, passive: true };
    let frame = 0;

    function measure() {
      frame = 0;
      if (!mobile.matches || !bar.isConnected) {
        root.style.removeProperty('--feather-cart-bar-height');
        root.style.removeProperty('--feather-cart-viewport-offset');
        return;
      }
      const viewport = window.visualViewport;
      const offset = viewport && Math.abs(viewport.scale - 1) < 0.01
        ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
        : 0;
      root.style.setProperty('--feather-cart-bar-height', `${Math.ceil(bar.getBoundingClientRect().height)}px`);
      root.style.setProperty('--feather-cart-viewport-offset', `${Math.ceil(offset)}px`);
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(measure);
    }

    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    observer?.observe(bar);
    window.addEventListener('resize', schedule, options);
    window.addEventListener('pageshow', schedule, options);
    window.visualViewport?.addEventListener('resize', schedule, options);
    window.visualViewport?.addEventListener('scroll', schedule, options);
    mobile.addEventListener('change', schedule, options);
    measure();

    cleanup = () => {
      controller.abort();
      observer?.disconnect();
      cancelAnimationFrame(frame);
      root.style.removeProperty('--feather-cart-bar-height');
      root.style.removeProperty('--feather-cart-viewport-offset');
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', initialise);
})();
